import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import type { RowSelectEventArgs } from '@syncfusion/ej2-react-grids';
import type { ClaimQueueItemView } from '../../../data/views';
import { claimDetailPath } from '../../../routes/routeConfig';

/**
 * Navigates to the US2 claim detail page when a queue row is selected (mirrors
 * `useWorklistNavigation`). The queue list query and grid stay read-only — row selection is used
 * only for navigation, not for any edit affordance.
 */
export const useClaimNavigation = () => {
  const navigate = useNavigate();

  const handleRowSelected = useCallback(
    (args: RowSelectEventArgs) => {
      const row = args.data as ClaimQueueItemView;
      if (row?.id)
        navigate(claimDetailPath(row.id));
    },
    [navigate],
  );

  return { handleRowSelected };
};
